import { MsalProvider } from "@azure/msal-react";
import React from "react";
import { observer } from "mobx-react";
import { usePublicClientApplication } from "./usePublicClientApplication";
import { Spinner } from "@fluentui/react-components";

const AuthProviderBase = (props: { children: React.ReactNode }) => {
    const { msalInstance, isInitialized, msalInstanceKey } = usePublicClientApplication();

    return isInitialized ? (
        <MsalProvider instance={msalInstance} key={msalInstanceKey}>
            {props.children}
        </MsalProvider>
    ) : (
        <Spinner label="Please wait while we are signing you in" aria-label="Please wait while we are signing you in" />
    );
};

export const AuthProvider = observer(AuthProviderBase);
